import React from 'react';
import AssetDetailsModal from '../components/AssetDetailsModal';

function AssetDetailsModalContainer(props) {
  return (
    <AssetDetailsModal {...props} />);

}

export default AssetDetailsModalContainer;